var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from './Tooltip.module.scss';
import { IDENTIFIER_TOOLTIP } from 'src/ui/components/ToolTip/constants';
export var E_TOOLTIP_POSITION;
(function (E_TOOLTIP_POSITION) {
    E_TOOLTIP_POSITION["TOP"] = "top";
    E_TOOLTIP_POSITION["LEFT"] = "left";
    E_TOOLTIP_POSITION["RIGHT"] = "right";
    E_TOOLTIP_POSITION["BOTTOM"] = "bottom";
    E_TOOLTIP_POSITION["TOP_LEFT"] = "top-left";
})(E_TOOLTIP_POSITION || (E_TOOLTIP_POSITION = {}));
export var Tooltip = function (props) {
    var _a;
    var children = props.children, _b = props.position, position = _b === void 0 ? E_TOOLTIP_POSITION.TOP : _b, className = props.className;
    var tooltipRef = useRef(null);
    useEffect(function () {
        var parentElement = tooltipRef.current.parentElement;
        var TOOLTIP_PARENT_CLASS = 'tooltip-parent';
        if (!parentElement.classList.contains(TOOLTIP_PARENT_CLASS)) {
            parentElement.classList.add(TOOLTIP_PARENT_CLASS);
        }
    });
    var tooltipClassNames = classNames('tooltip', styles.tooltipWrapper, (_a = {}, _a[styles[position]] = true, _a), className);
    return (_jsx("div", __assign({ ref: tooltipRef, "data-test": IDENTIFIER_TOOLTIP, role: "tooltip", className: tooltipClassNames }, { children: children })));
};
